import React from 'react'
import { SearchParams } from '../types'

interface SearchResultsProps {
  searchParams: SearchParams
}

const SearchResults: React.FC<SearchResultsProps> = ({ searchParams }) => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">Search Results</h1>
      <p className="text-gray-600 mb-8">
        Showing results for: {searchParams.city || 'Anywhere'} • 
        {searchParams.check_in && searchParams.check_out ? ` ${searchParams.check_in} to ${searchParams.check_out}` : ' Any dates'} • 
        {searchParams.guests} {searchParams.guests === 1 ? 'guest' : 'guests'}
      </p>
      
      <div className="bg-white rounded-lg shadow p-8 text-center">
        <h2 className="text-2xl font-semibold mb-4">No properties found</h2>
        <p className="text-gray-600 mb-4">
          There are no properties in the database yet. Property owners can create listings using the API.
        </p>
        <p className="text-sm text-gray-500">
          Use the API endpoint: POST /api/properties to create property listings
        </p>
      </div>
    </div>
  )
}

export default SearchResults
